import { 
  Brain, 
  Cloud, 
  Smartphone, 
  Database, 
  Code, 
  Cpu,
  Container,
  LineChart,
  Sparkles,
  Zap,
  Boxes,
  Network
} from 'lucide-react';

export const techCategories = [
  {
    category: 'Artificial Intelligence & ML',
    icon: Brain,
    color: 'from-purple-500 to-pink-500',
    technologies: [
      'OpenAI GPT-4 & GPT-5',
      'Google Gemini',
      'Claude AI',
      'TensorFlow',
      'PyTorch',
      'Scikit-learn',
      'Hugging Face',
      'LangChain',
      'Vector Databases',
      'RAG Systems',
      'Computer Vision',
      'Natural Language Processing'
    ]
  },
  {
    category: 'Cloud Platforms',
    icon: Cloud,
    color: 'from-blue-500 to-cyan-500',
    technologies: [
      'Amazon Web Services (AWS)',
      'Microsoft Azure',
      'Google Cloud Platform',
      'IBM Cloud',
      'Oracle Cloud',
      'DigitalOcean',
      'Serverless Architecture',
      'Lambda Functions'
    ]
  },
  {
    category: 'Frontend Technologies',
    icon: Code,
    color: 'from-green-500 to-emerald-500',
    technologies: [
      'React.js',
      'Next.js 14',
      'Vue.js',
      'Angular',
      'TypeScript',
      'Tailwind CSS',
      'Redux',
      'GraphQL',
      'Webpack',
      'Vite'
    ]
  },
  {
    category: 'Backend Technologies',
    icon: Cpu,
    color: 'from-orange-500 to-red-500',
    technologies: [
      'Node.js',
      'Python',
      'Java Spring Boot',
      '.NET Core',
      'Go (Golang)',
      'Ruby on Rails',
      'FastAPI',
      'Express.js',
      'Django',
      'Flask'
    ]
  },
  {
    category: 'Databases',
    icon: Database,
    color: 'from-indigo-500 to-purple-500',
    technologies: [
      'MongoDB',
      'PostgreSQL',
      'MySQL',
      'Redis',
      'Elasticsearch',
      'Cassandra',
      'DynamoDB',
      'Pinecone',
      'Supabase',
      'Firebase'
    ]
  },
  {
    category: 'DevOps & Infrastructure',
    icon: Container,
    color: 'from-teal-500 to-green-500',
    technologies: [
      'Docker',
      'Kubernetes',
      'Jenkins',
      'GitHub Actions',
      'GitLab CI/CD',
      'Terraform',
      'Ansible',
      'Prometheus',
      'Grafana',
      'ELK Stack'
    ]
  },
  {
    category: 'Mobile Development',
    icon: Smartphone,
    color: 'from-pink-500 to-rose-500',
    technologies: [
      'React Native',
      'Flutter',
      'Swift (iOS)',
      'Kotlin (Android)',
      'Ionic',
      'Xamarin',
      'Progressive Web Apps',
      'Mobile-First Design'
    ]
  },
  {
    category: 'Data & Analytics',
    icon: LineChart,
    color: 'from-yellow-500 to-orange-500',
    technologies: [
      'Apache Spark',
      'Apache Kafka',
      'Tableau',
      'Power BI',
      'Apache Airflow',
      'Pandas',
      'NumPy',
      'Big Data Analytics',
      'Data Warehousing',
      'ETL Pipelines'
    ]
  },
  {
    category: 'Blockchain & Web3',
    icon: Boxes,
    color: 'from-cyan-500 to-blue-500',
    technologies: [
      'Ethereum',
      'Solidity',
      'Web3.js',
      'Smart Contracts',
      'NFT Development',
      'DeFi Solutions',
      'Polygon',
      'Hyperledger'
    ]
  },
  {
    category: 'Emerging Technologies',
    icon: Sparkles,
    color: 'from-violet-500 to-purple-500',
    technologies: [
      'Edge Computing',
      'IoT Integration',
      'AR/VR Development',
      'Quantum Computing',
      '5G Applications',
      'Digital Twins',
      'Metaverse Solutions',
      'Robotics Process Automation'
    ]
  },
  {
    category: 'API & Integration',
    icon: Network,
    color: 'from-blue-500 to-indigo-500',
    technologies: [
      'RESTful APIs',
      'GraphQL',
      'gRPC',
      'WebSockets',
      'Microservices',
      'API Gateway',
      'OAuth 2.0',
      'JWT Authentication'
    ]
  },
  {
    category: 'Performance & Security',
    icon: Zap,
    color: 'from-red-500 to-pink-500',
    technologies: [
      'CDN (CloudFlare)',
      'Load Balancing',
      'SSL/TLS',
      'Penetration Testing',
      'OWASP Standards',
      'Zero Trust Security',
      'Encryption',
      'DDoS Protection'
    ]
  }
];
